import moment from "moment-timezone";
import { GuidRegex } from "../const/regex-pattern";

export const validateGuid=( data:any )=> {
    let s = "" + data;
    let regex = s.match(GuidRegex);
    if (regex === null) {
      return false;
    }
    return true;
}


export const convertDateToFormatDDMMYYYY = (str: string) => {
  const [DD, MM, YYYY] = str.split('/');
  const date = new Date(+YYYY, +MM - 1, +DD);
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
}


export const convertDateToFormatYYYYMMDD=(str:string)=>
{
  const [DD, MM, YYYY] = str.split('/');
  const date = new Date(+YYYY, +MM - 1, +DD);     
  var mnth = ("0" + (date.getMonth()+1)).slice(-2),
  day  = ("0" + date.getDate()).slice(-2);
  var year = date.getFullYear();
  return `${year}-${mnth}-${day}`;
}

/** Parse API date (ISO datetime or DD/MM/YYYY) to YYYY-MM-DD without timezone shift */
export const parseApiDateToYYYYMMDD = (str: string): string => {
  if (!str?.trim() || str === "01/01/0001") {
    return "";
  }
  if (str.includes("T") || /^\d{4}-\d{2}-\d{2}/.test(str)) {
    return moment(str).format("YYYY-MM-DD");
  }
  return convertDateToFormatYYYYMMDD(str);
};

/** Format YYYY-MM-DD form date for API as YYYY-MM-DDTHH:mm:ss without timezone shift */
export const formatFormDateForApi = (dateStr: string): string | null => {
  if (!dateStr?.trim()) {
    return null;
  }
  return moment(dateStr, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss");
};

export function convertUtcToLocalDate(utcDate:string,format:number)
{
  try{
    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
    var offset = new Date().getTimezoneOffset();
    let dateObj:any=new Date(utcDate);
    dateObj.setMinutes(dateObj.getMinutes() - offset);

    var curr_date = dateObj.getDate();
    var curr_month = dateObj.getMonth()+ 1;
    var curr_year = dateObj.getFullYear();
    var curr_min = dateObj.getMinutes();
    var curr_hr= dateObj.getHours()
    var curr_sc= dateObj.getSeconds();

    if(curr_month.toString().length == 1)
    curr_month = '0' + curr_month;      
    if(curr_date.toString().length == 1)
    curr_date = '0' + curr_date;
    if(curr_hr.toString().length == 1)
    curr_hr = '0' + curr_hr;
    if(curr_min.toString().length == 1)
    curr_min = '0' + curr_min;

    switch(format)
    {
        case 1: return curr_date + "-"+curr_month+ "-"+curr_year; //dd-mm-yyyy
        case 2: return curr_year + "-"+curr_month+ "-"+curr_date; //yyyy-mm-dd
        case 3: return curr_date + "/"+curr_month+ "/"+curr_year; //dd/mm/yyyy
        case 4: return curr_month+"/"+curr_date +"/"+curr_year+ " "+curr_hr+":"+curr_min;  // MM/dd/yyyy HH:mm:ss 24 Hours
        case 5: return curr_month+"/"+curr_date +"/"+curr_year+ " "+convertTime(curr_hr+":"+curr_min); // MM/dd/yyyy HH:mm:ss 12 Hours 
        case 6: return curr_date + "-"+curr_month; //dd-mm
        case 7: return curr_month+"-"+curr_date +"-"+curr_year+ " "+convertTime(curr_hr+":"+curr_min); // MM-dd-yyyy HH:mm:ss 12 Hours 
        case 8: return convertTime(curr_hr+":"+curr_min); //HH:mm:ss am||pm Hours
        
        case 9: return curr_date +"-"+monthNames[dateObj.getMonth()] +"-"+curr_year+ " "+convertTime(curr_hr+":"+curr_min); // dd-mmm-yyyy HH:mm:ss 12 Hours 
        case 10:return curr_date +"-"+monthNames[dateObj.getMonth()] +"-"+curr_year; // dd-mmm-yyyy 
        case 11: return monthNames[dateObj.getMonth()] ; // mmm 
        case 12: return curr_date ; //dd
        case 13: return curr_date + "-"+curr_month+ "-"+curr_year+ " "+convertTime(curr_hr+":"+curr_min); //dd-mm-yyyy  HH:mm:ss 12 Hours 

        default: return '';
    }
  }catch(err){
    return '';
  }    
}

function convertTime(time) {
  // Check correct time format and split into components
  time = time.toString().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
    if(time[0].toString().length==1)
    time[0]='0' + time[0];
  }
  return time.join (''); // return adjusted time or original string
}

export function IsTodayDate(utcDate:string)
{
  try{
    var offset = new Date().getTimezoneOffset();
  let dateObj:any=new Date(utcDate);
  dateObj.setMinutes(dateObj.getMinutes() - offset);
  var curr_date = dateObj.getDate();
  var curr_month = dateObj.getMonth()+ 1;
  var curr_year = dateObj.getFullYear();

  var todayDate=new Date();
  var todayD=todayDate.getDate();
  var todayM = dateObj.getMonth()+ 1;
  var todayY = dateObj.getFullYear();

  if(curr_date+curr_month+curr_year===todayD+todayM+todayY){
    return true;
  }else{
    return false;
  }
}catch(err){
    return false;
  }
}

export function validateImageType(file,fileExtensionArray) { 
  var sFileName = file.name;
    if (sFileName.length > 0) {
        var blnValid = false;
        for (var j = 0; j < fileExtensionArray.length; j++) {
            var sCurExtension = fileExtensionArray[j];
            if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                blnValid = true;
                break;
            }
        }        
        if (!blnValid) {
          return false;
      }
    }  
    return true;
};

// If find date in this format like DD-monthname-YYYY
export const formatDate = (dateString) => {
  const dateArray = dateString.split("/");
  const formattedDate = new Date(dateArray[2], dateArray[1] - 1, dateArray[0])
    .toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

  return formattedDate;
};
//display timezone time in Edit sellercalendar
export function convertDateTimeOnEdit(inputDate) {
  const momentDate = moment(inputDate);
  const formattedDate = momentDate.format("YYYY-MM-DDTHH:mm:ss");
  return formattedDate;
}
//display timezone time in Edit AM/PM format
export function formatTimeInAMPM(inputDate) {
  const momentDate = moment(inputDate);
  const formattedTime = momentDate.format("hh:mm A");
  return formattedTime;
}

// export function generateBookingSlots(startTime, endTime, interval, bookedSlots) {
//   let slots = [];
//   let currentDate = new Date(startTime);

//   while (currentDate < endTime) {
//       let hours = currentDate.getHours();
//       let minutes: string | number = currentDate.getMinutes();
//       let ampm = hours >= 12 ? 'PM' : 'AM';
//       // Convert hours to 12-hour format
//       hours = hours % 12;
//       hours = hours ? hours : 12; // 0 should be converted to 12
//       // Add leading zeros to minutes if necessary
//       minutes = minutes < 10 ? '0' + minutes : minutes;
//       // Construct the time string
//       let timeSlot = hours + ':' + minutes + ' ' + ampm;
//       // Check if the current time slot is not before a booked slot
//       while (isBeforeBookedSlot(currentDate, bookedSlots)) {
//           currentDate.setMinutes(currentDate.getMinutes() + interval);
//       }
//       // Check if the current time slot is not already booked
//       if (!isBooked(currentDate, bookedSlots)) {
//           // Add the time slot to the list
//           slots.push(timeSlot);
//       }
//       // Increment current time by interval minutes
//       currentDate.setMinutes(currentDate.getMinutes() + interval);
//   }
//   return slots;
// }
function isBooked(currentDate, bookedSlots) {
  for (let i = 0; i < bookedSlots.length; i++) {
      let bookedTime = new Date(bookedSlots[i]);
      if (
          currentDate.getHours() === bookedTime.getHours() &&
          currentDate.getMinutes() === bookedTime.getMinutes()
      ) {
          return true;
      }
  }
  return false;
}

// ---------------------------- BookingConsultation Function start--------------------------------------------------------------------
// Generate time slots function-

  function newtimeZone(timeString: string, timeZone: string): string {
    return moment(timeString, 'HH:mm', true).isValid() && timeZone
      ? moment.tz(timeString, 'HH:mm', moment.tz.guess()).tz(timeZone).format('HH:mm')
      : '';
  }

export function generateTimeSlots(timeRange: any, duration: any, timeZone: string) {
  const slots: any[] = [];

  const stime = newtimeZone(timeRange?.start, timeZone )
  const etime = newtimeZone(timeRange?.end, timeZone )

  let [currentHour, currentMinutes] = stime.split(':')?.map(Number);
  const [endHour, endMinutes] = etime.split(':')?.map(Number);
  let endTimeInMinutes = endHour * 60 + endMinutes;
  let currentTimeInMinutes = currentHour * 60 + currentMinutes;

  // Handle the case where end time is before start time
  if (endTimeInMinutes < currentTimeInMinutes) {
    // PM time range
    while (currentTimeInMinutes < 24 * 60) {
      const start = new Date(0, 0, 0, currentHour, currentMinutes);
      const end = new Date(0, 0, 0, currentHour, currentMinutes + duration);
      slots.push({
        start: start?.toTimeString()?.substring(0, 5),
        end: end?.toTimeString()?.substring(0, 5),
      });
      currentTimeInMinutes += duration + 1;
      currentHour = Math.floor(currentTimeInMinutes / 60);
      currentMinutes = currentTimeInMinutes % 60;
    }
    // AM time range
    currentHour = 0; // Reset to start of the day
    currentMinutes = 0;
    endTimeInMinutes += 24 * 60; // Add a day to the end time
  }

  // Generate time slots as before for the rest of the day
  while (currentTimeInMinutes + duration <= endTimeInMinutes) {
    const start = new Date(0, 0, 0, currentHour, currentMinutes);
    const end = new Date(0, 0, 0, currentHour, currentMinutes + duration);
    slots.push({
      start: start?.toTimeString()?.substring(0, 5),
      end: end?.toTimeString()?.substring(0, 5),
    });
    currentTimeInMinutes += duration ;
    currentHour = Math.floor(currentTimeInMinutes / 60);
    currentMinutes = currentTimeInMinutes % 60;
  }
  return slots;
}


// for filter
export function filterSlotsWithinWorkingHours(slots:any, companyTime:any) {
  const filteredSlots = slots?.filter(slot => {
      const slotStartTimeMinutes = convertTimeToMinutes(slot?.start);
      const slotEndTimeMinutes = convertTimeToMinutes(slot?.end);
      const companyStartTimeMinutes = convertTimeToMinutes(companyTime?.startTime);
      const companyEndTimeMinutes = convertTimeToMinutes(companyTime?.endTime);
      return slotStartTimeMinutes >= companyStartTimeMinutes && slotEndTimeMinutes <= companyEndTimeMinutes;
  });
  return filteredSlots;
}
// Helper function to convert time in "HH:MM" format to minutes
function convertTimeToMinutes(time:any) {
  const [hours, minutes] = time?.split(':')?.map(Number);
  return hours * 60 + minutes ;
}
// ---------------------------------BookingConsultation Function end-----------------------------------------------------------
// Function to check if the current time is before any booked slot
function isBeforeBookedSlot(currentDate, bookedSlots) {
  for (let i = 0; i < bookedSlots.length; i++) {
      let bookedTime = new Date(bookedSlots[i]);

      // Check if the current time is before the booked slot
      if (currentDate < bookedTime) {
          return true;
      }
  }
  return false;
}

//timezone function for meeting
export  function convertTimestampToTimezone(timestamp, timezone) {
  // Convert the Unix timestamp to milliseconds
  const milliseconds = parseInt(timestamp);
  // Create a moment object using the timestamp and timezone
  const dateTime = moment.tz(milliseconds, timezone);
  // Format the datetime as per your requirements
  const formattedDatetime = dateTime.format('YYYY-MM-DD HH:mm:ss');
  return formattedDatetime;
}

//function for not select past date
export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month:any = today.getMonth() + 1;
  let day:any = today.getDate();
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  return `${year}-${month}-${day}`;
};
// restict white space
export const restrictWhiteSpace = (value: string): string => {
  return value.replace(/\s+/g, ' ').trimStart();
};

export function createUrlSlug(text: string): string {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '') // Remove special characters except hyphens
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .trim();
  }

/**
 * Parses consultation category IDs that may be pipe-separated
 * @param consultationCategoryId - The category ID string that may contain pipe-separated values
 * @returns Array of category IDs
 * 
 * @example
 * parseConsultationCategoryIds("324c5bb5-42a3-4777-8f6b-22f6e268cbb9|da35db4b-7fd6-4d0e-a161-a43fbdceda08")
 * // Returns: ["324c5bb5-42a3-4777-8f6b-22f6e268cbb9", "da35db4b-7fd6-4d0e-a161-a43fbdceda08"]
 * 
 * parseConsultationCategoryIds("324c5bb5-42a3-4777-8f6b-22f6e268cbb9")
 * // Returns: ["324c5bb5-42a3-4777-8f6b-22f6e268cbb9"]
 * 
 * parseConsultationCategoryIds("")
 * // Returns: []
 */
export const parseConsultationCategoryIds = (consultationCategoryId: string): string[] => {
  if (!consultationCategoryId) return [];
  
  return consultationCategoryId.includes('|') 
    ? consultationCategoryId.split('|').filter(id => id.trim() !== '')
    : [consultationCategoryId];
};

// Global function to format weekday based on screen size
export function getWeekdayFormat(): 'long' | 'short' {
  if (typeof window !== 'undefined') {
    // Use 575.98px as the breakpoint to match CSS media queries
    // Returns 'short' for screens <= 575.98px, 'long' for screens > 575.98px
    const screenWidth = window.innerWidth || window.screen.width;
    const isMobile = screenWidth <= 575.98;

    return isMobile ? 'short' : 'long';
  }
  return 'short'; // Default fallback for mobile-first approach
}


